export default __webpack_public_path__ + "static/media/resume.b9581bef.pdf";